import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { FaExternalLinkAlt } from 'react-icons/fa';
import Paper from '@material-ui/core/Paper';
import Modal from 'react-modal';
import './Modal.css';
import { Box } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Chip from '@material-ui/core/Chip';

const contentStyles = {
  content: {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0
  }
};

const useStyles = makeStyles({
  container: {
    display: 'flex',
    alignItems: 'center'
  },
  root: {
    width: '14em',
    margin: '0.5em'
  },
  media: {
    height: 'auto'
  },
  content: {
    textAlign: 'center',
    borderTop: '1px solid lightgrey',
    borderBottom: '1px solid lightgrey'
  },
  actions: {
    justifyContent: 'center',
    cursor: 'default'
  },
  modal: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  projectTile: {
    maxWidth: '500px',
    textAlign: 'center',
    width: '100%',
    padding: '0.5em',
    margin: '1em'
  },
  projectImage: {
    width: 300,
    border: '1px solid lightgray',
    borderRadius: '3px'
  },
  projectBox: {
    // display: 'flex'
  },
  projectImageBox: {
    padding: '0.5em'
  },
  projectTextBox: {
    padding: '0.5em',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-evenly'
  },
  projectList: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center'
  },
  closeIcon: {
    width: '100%',
    textAlign: 'right'
  },
  urlBox: {
    padding: '0.5em'
  },
  chipBox: {
    padding: '0.5em'
  }
});

const ProjectCards = props => {
  const [isModalOpen, setModalOpen] = useState(false);
  const [currentCardIdx, setCurrentCardIdx] = useState(null);
  const classes = useStyles();
  const { widget } = props;
  const { data } = widget;

  useEffect(() => {
    Modal.setAppElement('#root');
  }, []);

  const onHandleModalOpen = () => {
    document.body.style.overflow = 'hidden';
    setSelectedCardActive();
  };

  const onHandleModalClose = () => {
    document.body.style.overflow = 'unset';
    setCurrentCardIdx(null);
  };

  const setSelectedCardActive = () => {
    if (currentCardIdx !== null) {
      const currentCard = document.querySelectorAll(
        '.ReactModalPortal .MuiPaper-root'
      )[currentCardIdx];
      currentCard.style.backgroundColor = 'gold';
      currentCard.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'center'
      });
    }
  };

  const handleModalVisibility = ({ isOpen, selectedCard = null }) => {
    setModalOpen(isOpen);
    if (selectedCard !== null) {
      setCurrentCardIdx(selectedCard);
    }
  };

  const ShowMoreProjects = () => {
    const classes = useStyles();

    return (
      <Card className={classes.root}>
        <CardActionArea>
          <CardContent className={classes.content}>
            <Typography gutterBottom variant='h5' component='h3'>
              Show More
            </Typography>
            <Typography variant='body2' color='textSecondary'>
              <FaExternalLinkAlt color='secondary' className='fa-icon' />
            </Typography>
            <Typography variant='body2' color='textSecondary'>
              There's more! See more in new window!
            </Typography>
          </CardContent>
        </CardActionArea>
        <CardActions className={classes.actions}>
          <Button
            size='small'
            color='primary'
            onClick={() => handleModalVisibility({ isOpen: true })}
          >
            Open In Window
          </Button>
        </CardActions>
      </Card>
    );
  };

  const ShowAllProjectsModal = () => {
    return (
      <div className='show-more-button'>
        <Modal
          closeTimeoutMS={300}
          isOpen={isModalOpen}
          onRequestClose={() => handleModalVisibility({ isOpen: false })}
          style={contentStyles}
          onAfterOpen={onHandleModalOpen}
          onAfterClose={onHandleModalClose}
        >
          <div className={classes.modal}>
            <Box className={classes.closeIcon}>
              <div className='close-modal-button-top'>
                <IconButton
                  onClick={() => handleModalVisibility({ isOpen: false })}
                >
                  <CloseIcon />
                </IconButton>
              </div>
            </Box>
            <Box>
              <h1>All Projects</h1>
            </Box>
            <Box className={classes.projectList}>
              {data.map((project, idx) => {
                const { desc, img, title, tools, url, urlText } = project;
                return (
                  <Paper key={idx} className={classes.projectTile}>
                    <h3>{title}</h3>
                    <Box className={classes.projectBox}>
                      <Box className={classes.projectImageBox}>
                        <img
                          className={classes.projectImage}
                          src={img}
                          alt={'project'}
                        />
                      </Box>
                      <Box className={classes.projectTextBox}>
                        <Typography
                          variant='body2'
                          color='textSecondary'
                          component='p'
                        >
                          <span>{desc}</span>
                        </Typography>
                      </Box>
                      {url && (
                        <Box className={classes.urlBox}>
                          <Typography
                            variant='body2'
                            color='textSecondary'
                            component='p'
                          >
                            {url && (
                              <a
                                className='goto-url'
                                href={url}
                                target='_blank'
                                rel='noopener noreferrer'
                              >
                                {urlText ? urlText : url}
                              </a>
                            )}
                          </Typography>
                        </Box>
                      )}
                      <Box className={classes.chipBox}>
                        {tools.split(',').map((tool, idx) => {
                          return (
                            <Chip
                              className='tool-chip'
                              color='secondary'
                              key={idx}
                              size='small'
                              label={tool}
                            />
                          );
                        })}
                      </Box>
                    </Box>
                  </Paper>
                );
              })}
            </Box>
            <Box className='close-modal-button-bottom'>
              <Button
                size='large'
                variant='contained'
                color='primary'
                className='close-modal'
                onClick={() => handleModalVisibility({ isOpen: false })}
              >
                Close This
              </Button>
            </Box>
          </div>
        </Modal>
      </div>
    );
  };

  return (
    <div className={classes.container}>
      {data.slice(0, 10).map((project, idx) => {
        const { client, img, shortDesc, title, vertical } = project;
        return (
          <Card key={idx} className={classes.root}>
            <CardActionArea
              onClick={() =>
                handleModalVisibility({ isOpen: true, selectedCard: idx })
              }
            >
              <CardMedia
                component='img'
                alt={title}
                width='100%'
                image={img}
                title={title}
              />
              <CardContent className={classes.content}>
                <Typography variant='h6' color='textSecondary'>
                  <span>{client || title}</span>
                </Typography>
                <Typography variant='body2' color='textSecondary' component='p'>
                  {shortDesc}
                </Typography>
              </CardContent>
            </CardActionArea>
            <CardActions className={classes.actions}>
              <Typography
                variant='body2'
                color='textSecondary'
                component='span'
              >
                {vertical}
              </Typography>
            </CardActions>
          </Card>
        );
      })}
      <ShowMoreProjects />
      <ShowAllProjectsModal />
    </div>
  );
};

export default ProjectCards;
